import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, CloseBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import { itemCategoriesMng } from '../api/itemCategoriesMng';
import ItemCategoryForm from './ItemCategoryForm';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

function AddItemCategoryDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { open, onClose, onAdd = () => {} } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState();

  const createItemCategory = async () => {
    setLoading(true);
    const itemCategory = { ...formData };
    delete itemCategory.isValid;
    try {
      await itemCategoriesMng.addItemCategory(itemCategory);
      onAdd();
      _onClose();
      toast.success('Item category added successfully', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const _onClose = () => {
    setFormData({});
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        Add Item Category
        <CloseBtn
          onClick={() => {
            onClose();
          }}
        />
      </DialogTitle>
      <DialogContent>
        <ItemCategoryForm
          onChange={(data) => {
            console.log('on change');
            console.log(data);
            setFormData({ ...data });
          }}
          values={formData}
        />
        <div
          style={{
            marginBottom: '20px',
            marginTop: '10px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || !formData || !formData.isValid}
            label={<span>Add Item Category</span>}
            onClick={createItemCategory}
            onEnter={createItemCategory}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

AddItemCategoryDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
};

AddItemCategoryDialog.defaultProps = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: () => {},
};

export default AddItemCategoryDialog;
